import { Box, useTheme } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import Crown from '../svg/Crown'

interface FreemiumDotProps {
  sx?: SxProps<Theme>
  size?: number
  showCrown?: boolean
  iconSize?: 'medium' | 'small'
  crownSize?: number
}

const iconPixels = {
  medium: 24,
  small: 20
}

export default function FreemiumDot({ sx, size = 8, showCrown, iconSize, crownSize }: Readonly<FreemiumDotProps>) {
  const theme = useTheme()
  let pixelSize = size
  if (iconSize) {
    pixelSize = iconPixels[iconSize]
  }
  return (
    <Box
      sx={{
        ...sx,
        borderRadius: 100,
        background: theme.palette.groupsy.gradient,
        minHeight: `${pixelSize}px`,
        height: `${pixelSize}px`,
        minWidth: `${pixelSize}px`,
        width: `${pixelSize}px`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {showCrown && <Crown color="#FFFFFF" size={crownSize ?? pixelSize * 0.67} sx={{ display: 'flex', justifyContent: 'center' }} />}
    </Box>
  )
}
